import type { GroupMembership } from '../models/users'
import { logout } from './auth'

class SessionTimer {
  sessionTimerMinutes: number | null
  sessionTimerId: null | NodeJS.Timeout

  constructor() {
    this.sessionTimerMinutes = null
    this.sessionTimerId = null
  }

  isActive(): boolean {
    return Boolean(this.sessionTimerId)
  }

  startTimerForGroups(groups: GroupMembership[] | undefined) {
    if (!groups) {
      return
    }
    const minutes = groups.reduce((acc, gr) => {
      if (!gr.sessionTimeout) {
        return acc
      }
      return Math.min(gr.sessionTimeout, acc)
    }, Number.MAX_SAFE_INTEGER)

    if (minutes < Number.MAX_SAFE_INTEGER) {
      this.startTimer(minutes)
    }
  }

  startTimer(minutes: number | null): void {
    if (minutes === null) {
      return
    }
    this.sessionTimerMinutes = minutes
    this.clearTimer()
    if (this.sessionTimerMinutes > 0) {
      this.sessionTimerId = setTimeout(
        () => {
          logout()
          this.sessionTimerId = null
        },
        this.sessionTimerMinutes * 60 * 1000,
      )
    }
  }

  clearTimer(): void {
    if (this.sessionTimerId) {
      clearTimeout(this.sessionTimerId)
    }
    this.sessionTimerId = null
  }

  resetTimer(): void {
    this.clearTimer()
    this.startTimer(this.sessionTimerMinutes)
  }
}

export const sessionTimer = new SessionTimer()
